import { IAPIPaginationResponse } from "./IAPIResponse";

 
 
export class APIResponseModel<T> {
    result: NonNullable<[T]> | NonNullable<T> | null;
    pagination: IAPIPaginationResponse;
    constructor(data: Partial<APIResponseModel<T>>) {
        this.result = (data.result && data.result) || null;
        this.pagination = data.pagination
            ? new PaginationModel()
            : PaginationModel.deserialize(data.pagination || new PaginationModel());
    }
}

export class PaginationModel {
    pageSize: number;
    pageNumber: number;
    pageCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
    isLastPage: boolean;
    totalItemCount: number;
    constructor(data?: Partial<PaginationModel>) {
        this.pageSize = data?.pageSize || 25;
        this.pageNumber = data?.pageNumber || 1;
        this.pageCount = data?.pageCount || 0;
        this.hasPreviousPage = data?.hasPreviousPage === true;
        this.hasNextPage = data?.hasNextPage === true;
        this.isLastPage = data?.isLastPage === true;
        this.totalItemCount = data?.totalItemCount || 0;
    }

    static deserialize(data: IAPIPaginationResponse) {
        return new PaginationModel({
            pageSize: data.pageSize,
            pageNumber: data.pageNumber,
            pageCount: data.pageCount,
            hasPreviousPage: data.hasPreviousPage,
            hasNextPage: data.hasNextPage,
            isLastPage: data.isLastPage,
            totalItemCount: data.totalItemCount,
        });
    }
}
